import $ from "jquery";

class Formacao {
  constructor(loading) {
    this.loading = loading;
    this.events();
  }

  events() {
    if (document.querySelector("#add-nova-formacao")) {
      let add_formacao = document.querySelector("#add-nova-formacao");

      add_formacao.addEventListener("click", this.salvarFormacao.bind(this));

      $("#formacoes").on("click", ".deletar", (e) =>
        this.deletarFormacao.bind(this)(e)
      );
    }
  }

  deletarFormacao(e) {
    Swal.fire({
      title: "Confirmar",
      text: "Tens certeza que pretendes eliminar esta formação?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {

        let postID = $(e.target).data('id');
        this.loading.showLoadingAnimation()
        $.ajax({
            type: "DELETE",
            url: maisempregoData.root_url + "/wp-json/wp/v2/formacao/"+postID,
            dataType: "json",
            beforeSend: (xhr) => {
              xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
            },
            success: response => {
              this.loading.hideLoadingAnimation()
                let table = $("#myTable").DataTable();
                let row = $(e.target).closest("tr");
                let data = table.row(row).data(); // Get the data for the row
        
                table.row(row).remove().draw();
                Swal.fire("Eliminado!", "Formação eliminada com sucesso.", "success");
            
            },
            error: error => {
              this.loading.hideLoadingAnimation()
              console.log(error);
              Swal.fire(
                "Error!",
                "Ocorreu um error inesperado!",
                "error"
              );
            },
          });
      }
    });
  }

  salvarFormacao() {
    Swal.fire({
      title: "Cadastrar Formacao",

      html: `
            <form id="formacao-form">
                <div class="form-group ">
                    <label for="">Formacao</label>
                    <input type="text" name="formacao" id="formacao" required  placeholder="Digita a posição da vaga" />
                </div>
    
                <div class="form-group ">
                    <label for="">Descrição</label>
                    <textarea name="descricao" id="descricao" cols="30" rows="5"  ></textarea>
                </div>
            </form>
            `,
      showCancelButton: true,
      confirmButtonText: "Salvar",
      preConfirm: () => {
        const form = document.getElementById("formacao-form");
        if (!form.checkValidity()) {
          Swal.showValidationMessage("Preencha todos campos por favor!");
          return false;
        }

        // Retrieve form values
        let formacao = $("#formacao").val();
        let descricao = $("#descricao").val();

        // Prepare the AJAX request data
        let data = {
          title: formacao,
          status: "publish",
          acf: {
            formacao,
            descricao,
          },
        };

        // Make the AJAX request
        this.loading.showLoadingAnimation()
        $.ajax({
          type: "POST",
          url: maisempregoData.root_url + "/wp-json/wp/v2/formacao/",
          data: data,
          dataType: "json",
          beforeSend: (xhr) => {
            xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
          },
          success: response => {
            this.loading.hideLoadingAnimation()
            Swal.fire("Salvo!", "Formacao registada com sucesso!.", "success");

            let newRowData = [
                formacao,
               `<div class="text-center"><i data-id="${response.id}" class="fa-solid fa-trash-can text-red deletar"></i></div>`
                // Add more data for additional columns if needed
              ];

            let table = $('#myTable').DataTable();

            table.row.add(newRowData).draw();
            

            // let html = `
            // <tr>
            //     <td>${formacao}</td>
            //     <td align="center"></td>
            // </tr>
            // `;

            // $("#formacoes").append(html);

            // this.appedVagas(response)
          },
          error: error => {
            this.loading.hideLoadingAnimation()
            console.log(error);
            Swal.fire(
              "Error!",
              "Ocorreu um error no registo da formação.",
              "error"
            );
          },
        });

        // Prevent closing the SweetAlert dialog while AJAX request is in progress
        Swal.showLoading();

        // Prevent closing the dialog automatically
        return false;
      },

      customClass: {
        content: "my-swal-content",
        popup: "my-swal-container",
        confirmButton: "confirm-swal-button",
        cancelButton: "cancel-swal-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // Handle form submission success
        const { descricao, formacao } = result.value;
      }
    });
  }
}

export default Formacao;
